<template src="./template.html"></template>
<script>
import DetailPage from 'src/modules/pages/detail-page'
export default {
  name: 'Mekas',
  props: ['id', 'mode'],
  data () {
    return {
      scaffolding: {
        'items': {
          'item-1': {
            'indexColumn': true,
            'dataType': 'SingleArray',
            'editable': false,
            'inputKey': 1,
            'type': 'DataTable',
            'hideBottom': true,
            'pagination': {
              'rowsPerPage': 0,
              'descending': true
            },
            'fieldName': 'list',
            'addType': 'last',
            'fakeDelete': true,
            sortBy: 'displayName',
            'columns': [
              {
                label: 'Tên',
                fieldName: 'displayName',
                field: 'displayName',
                name: 'displayName',
                type: 'TextField',
                validation: 'required',
                align: 'center',
                sortable: true
              },
              {
                label: 'Mã NV',
                fieldName: 'mekaId',
                field: 'mekaId',
                name: 'mekaId',
                type: 'TextField',
                // '@tableOnly': {
                //   showFormat: 'props.row.color.name'
                // },
                // datasource: {
                //   options: [],
                //   label: 'name',
                //   value: 'id'
                // },
                align: 'center'
              },
              {
                label: 'Email',
                fieldName: 'email',
                field: 'email',
                name: 'email',
                type: 'TextField',
                align: 'center'
              },
              {
                label: 'Số điện thoại',
                fieldName: 'mobile',
                field: 'mobile',
                name: 'mobile',
                type: 'TextField',
                align: 'center'
              },
              {
                label: 'Ghi chú',
                fieldName: 'note',
                field: 'note',
                name: 'note',
                type: 'TextArea',
                align: 'center'
              },

            ]
          }
        }
      },
      queryPath: ['Masterdata', 'Meka'],
      data: []
    }
  },
  methods: {
    async handlerSubmit (payload, resolve, reject) {
      let vm = this
      let submitModel = { coll: 'Masterdata', id: 'Meka', data: payload.data }
      await vm.$command.execute('upMasterDatAID', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
  },
  created() {
    let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
    let roles = this._.get(this.permission, 'roles')
    let val = roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
    this.scaffolding.items['item-1'].editable = val
  },
  computed: {
    hasPerm: {
      get: function() {
        let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
        let roles = this._.get(this.permission, 'roles')
        return roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
      }
    },
    permission() {
      return this.$store.getters.permission
    }
  },
  watch: {
    permission (newValue) {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let roles = this._.get(newValue, 'roles')
      let val = roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
      this.scaffolding.items['item-1'].editable = val
    }
  },
  components: {
    DetailPage
  }
}
</script>
